/* בול פרקט - רשימת מועדפים. נכתב בשיחה 12, בבעלות שיחה 14 מ-15.10.
   נשמרת בדפדפן (localStorage, המפתח 'bp_wishlist', רשימת handle של מוצרים).
   לקוח מחובר: הרשימה נשמרת גם בחשבון (השדה bpk.wishlist), ועוברת בין מכשירים.
   הנתונים מהחשבון מגיעים מ-snippets/bp-club-wishlist-count (window.BPWlAcct), והשמירה דרך /apps/bp-club/wishlist
   (סניפט "אזור אישי - תמונת גוגל ומועדפים (14)").
   חשוב: הקובץ נטען מכמה מקומות בדף (הדר, כפתור הלב, עמוד המועדפים), ולכן רץ רק פעם אחת. */
(function () {
  if (window.BPWishlist) return;
  var KEY = 'bp_wishlist';
  var A = window.BPWlAcct || null;
  var BASE = A ? 'bp_wishlist_base_' + A.id : '';

  function get(k) { try { var a = JSON.parse(localStorage.getItem(k)); return Array.isArray(a) ? a : null; } catch (e) { return null; } }
  function put(k, a) { try { localStorage.setItem(k, JSON.stringify(a)); } catch (e) {} }
  function read() { return get(KEY) || []; }
  function same(a, b) { if (a.length !== b.length) return false; for (var i = 0; i < a.length; i++) { if (b.indexOf(a[i]) < 0) return false; } return true; }

  function counters() {
    var n = read().length;
    document.querySelectorAll('[data-bp-wishlist-count]').forEach(function (el) { if (el.textContent !== String(n)) el.textContent = String(n); el.style.display = n > 0 ? 'inline-block' : 'none'; });
    document.querySelectorAll('.bp-wl-head').forEach(function (el) { el.setAttribute('aria-label', n > 0 ? 'המועדפים שלי, ' + n + ' מוצרים' : 'המועדפים שלי'); });
  }
  function buttons() {
    var list = read();
    document.querySelectorAll('[data-bp-wishlist-btn]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-handle')) > -1;
      b.classList.toggle('active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'הסרה מהמועדפים' : 'הוספה למועדפים');
      b.setAttribute('title', on ? 'הסרה מהמועדפים' : 'הוספה למועדפים');
    });
  }
  /* הלב: צורה אחידה בכל האתר (הדר, דף מוצר, כרטיסי מוצר) */
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.3c-.3 0-.6-.1-.8-.3C7.4 16.6 2.5 12.6 2.5 8.4 2.5 5.6 4.7 3.5 7.4 3.5c1.8 0 3.4 1 4.6 2.6 1.2-1.6 2.8-2.6 4.6-2.6 2.7 0 4.9 2.1 4.9 4.9 0 4.2-4.9 8.2-8.7 11.6-.2.2-.5.3-.8.3z"/></svg>';
  window.BPWlHeart = HEART;
  function css() {
    if (document.getElementById('bp-wl-css')) return;
    var st = document.createElement('style');
    st.id = 'bp-wl-css';
    st.textContent =
      '.bp-wl-btn{position:relative;width:var(--bp-wl-size,40px);height:var(--bp-wl-size,40px);padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#043B20;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 8px rgba(4,59,32,.18);transition:transform .18s ease,background .18s ease;-webkit-tap-highlight-color:transparent}' +
      '.bp-wl-btn::after{content:"";position:absolute;inset:-6px}' +
      '.bp-wl-btn svg{width:52%;height:52%;display:block;overflow:visible}' +
      '.bp-wl-btn svg path,.bp-wl-head svg path{fill:none;stroke:currentColor;stroke-width:1.9;stroke-linejoin:round;transition:fill .2s ease,stroke .2s ease}' +
      '.bp-wl-btn:hover{transform:scale(1.08);background:#fff}' +
      '.bp-wl-btn:focus-visible{outline:2px solid #E7B752;outline-offset:2px}' +
      '.bp-wl-btn.active svg path{fill:#E7B752;stroke:#C99A2E}' +
      '.bp-wl-btn.bp-wl-pop svg{animation:bpWlPop .35s ease}' +
      '@keyframes bpWlPop{0%{transform:scale(1)}40%{transform:scale(1.3)}100%{transform:scale(1)}}' +
      '@media (prefers-reduced-motion:reduce){.bp-wl-btn,.bp-wl-btn svg{transition:none;animation:none!important}}' +
      '.bpnc-card{position:relative}' +
      '.bpnc-card>.bp-wl-btn{position:absolute;top:10px;left:10px;z-index:3;--bp-wl-size:36px}' +
      '.bp-wl-head svg{width:24px;height:24px;display:block;overflow:visible}';
    (document.head || document.documentElement).appendChild(st);
  }
  /* לב על כל כרטיס מוצר (דף הבית, קטגוריות, חיפוש, משלימים ומוצרים קשורים) */
  function handleOf(href) {
    try { var m = new URL(href, location.href).pathname.match(/\/products\/([^\/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; }
  }
  function decorate() {
    document.querySelectorAll('.bpnc-card:not([data-bp-wl])').forEach(function (card) {
      card.setAttribute('data-bp-wl', '1');
      var a = card.querySelector('a.bpnc-thumb') || card.querySelector('a[href*="/products/"]');
      var h = a ? handleOf(a.getAttribute('href')) : '';
      if (!h || card.querySelector('[data-bp-wishlist-btn]')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'bp-wl-btn'; b.innerHTML = HEART;
      b.setAttribute('data-bp-wishlist-btn', ''); b.setAttribute('data-handle', h);
      b.setAttribute('aria-pressed', 'false'); b.setAttribute('aria-label', 'הוספה למועדפים'); b.setAttribute('title', 'הוספה למועדפים');
      card.appendChild(b);
    });
  }
  /* הלבבות שמגיעים מהתבנית מקבלים את אותה צורה */
  function unify() {
    document.querySelectorAll('.bp-wl-btn:not([data-bp-wl-svg]), .bp-wl-head:not([data-bp-wl-svg])').forEach(function (el) {
      el.setAttribute('data-bp-wl-svg', '1');
      var old = el.querySelector('svg');
      if (old) { var t = document.createElement('span'); t.innerHTML = HEART; old.replaceWith(t.firstChild); }
    });
  }

  function refresh(a) { counters(); buttons(); document.dispatchEvent(new CustomEvent('bp:wishlist', { detail: a })); }

  /* שמירה בחשבון (רק ללקוח מחובר), עם המתנה קצרה כדי לאחד כמה לחיצות לבקשה אחת */
  var timer = null;
  function push() {
    if (!A) return;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var sent = read();
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'apps/bp-club/wishlist', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ handles: sent })
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (!j || !j.ok || !Array.isArray(j.handles)) return;
        A.h = j.handles;
        put(BASE, j.handles);
        /* מוצר שכבר לא קיים בחנות יורד גם מהרשימה בדפדפן, אם לא היו שינויים בינתיים */
        if (same(read(), sent) && !same(sent, j.handles)) { put(KEY, j.handles); refresh(j.handles); }
      }).catch(function () {});
    }, 700);
  }

  function write(a) { put(KEY, a); refresh(a); push(); }

  /* איחוד בכניסה: מה שבחשבון, ועוד מה שנוסף בדפדפן מאז הסנכרון האחרון, פחות מה שהוסר בדפדפן מאז */
  function sync() {
    if (!A) return;
    var remote = Array.isArray(A.h) ? A.h.slice() : [];
    var local = read();
    var base = get(BASE);
    var res;
    if (!base) {
      res = remote.slice();
      local.forEach(function (h) { if (res.indexOf(h) < 0) res.push(h); });
    } else {
      res = remote.filter(function (h) { return !(base.indexOf(h) > -1 && local.indexOf(h) < 0); });
      local.forEach(function (h) { if (base.indexOf(h) < 0 && res.indexOf(h) < 0) res.push(h); });
    }
    put(KEY, res);
    if (same(res, remote)) { put(BASE, res); } else { push(); }
  }

  window.BPWishlist = {
    read: read, write: write,
    toggle: function (h) { if (!h) return; var a = read(); var i = a.indexOf(h); if (i > -1) a.splice(i, 1); else a.push(h); write(a); },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); },
    clear: function () { write([]); }
  };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bp-wishlist-btn]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    window.BPWishlist.toggle(b.getAttribute('data-handle'));
    if (b.classList.contains('active')) { b.classList.remove('bp-wl-pop'); void b.offsetWidth; b.classList.add('bp-wl-pop'); }
  }, true);
  /* עדכון בין לשוניות פתוחות */
  window.addEventListener('storage', function (e) { if (e.key === KEY) { counters(); buttons(); } });

  sync();
  css();
  function init() { decorate(); unify(); counters(); buttons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* כרטיסים שנטענים אחר כך (סינון, גלילה, מוצרים קשורים) */
  if ('MutationObserver' in window) {
    var pend = false;
    new MutationObserver(function () { if (pend) return; pend = true; setTimeout(function () { pend = false; decorate(); unify(); buttons(); counters(); }, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
